export const initialState = {
  installationQueue: [],
  appToInstall: null,
  config: null,
  error: "",
  successFunction: null,
};

export const AppActionType = {
  ADD_TO_INSTALLATION_QUEUE: "ADD_TO_INSTALLATION_QUEUE",
  REMOVE_FROM_INSTALLATION_QUEUE: "REMOVE_FROM_INSTALLATION_QUEUE",
  SET_INSTALLING_APP: "SET_INSTALLING_APP",
  APP_INSTALLED: "APP_INSTALLED",
};
export function appInstallationReducer(state = initialState, action) {
  switch (action.type) {
    case AppActionType.ADD_TO_INSTALLATION_QUEUE: {
      const { appid, config, successFunction } = action.payload;
      return {
        ...state,
        config,
        successFunction,
        installationQueue: [...state.installationQueue, appid],
      };
    }
    case AppActionType.REMOVE_FROM_INSTALLATION_QUEUE: {
      const { appid } = action.payload;
      return {
        ...state,
        config: null,
        installationQueue: state.installationQueue.filter(
          (item) => item !== appid
        ),
      };
    }
    case AppActionType.SET_INSTALLING_APP: {
      const { appid } = action.payload;
      return {
        ...state,
        appToInstall: appid,
      };
    }
    case AppActionType.APP_INSTALLED: {
      const { appid } = action.payload;
      return {
        ...state,
        config: null,
        installationQueue: state.installationQueue.filter(
          (item) => item !== appid
        ),
        appToInstall: null,
      };
    }
    default:
      return state;
  }
}
